<p-dialog header="実施報告詳細" [(visible)]="boardFlag" [modal]="true" [responsive]="true" [styleClass]="'main-dialog'"
  (onHide)="closeDialog()">
  <div class="main-height">
    <div>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-12 p-jc-center">
          <p-table [value]="data">
            <ng-template pTemplate="header"> </ng-template>
            <ng-template pTemplate="body" let-data>
              <tr>
                <td class="legend-cell bold">
                  <label for="school" class="school-label bold">団体名</label>
                </td>
                <td class="non-edit-cell">
                  {{ class_id == '1' ? data?.seeds_organization_name : data?.needs_organization_name }}
                </td>
              </tr>
              <tr>
                <td class="legend-cell bold">
                  <label for="school" class="school-label bold">マッチング先</label>
                </td>
                <td class="non-edit-cell">
                  {{ class_id == '1' ? data?.needs_organization_name : data?.seeds_organization_name }}
                </td>
              </tr>
              <ng-container *ngIf="class_id == '2'">
                <tr>
                  <td class="legend-cell bold">
                    <label for="school" class="school-label bold">参加乳幼児の年齢・人数</label>
                  </td>
                  <td class="non-edit-cell">
                    {{ data?.desired_people_number }}
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="class_id == '1'">
                <tr>
                  <td class="legend-cell bold">
                    <label for="school" class="school-label bold">参加生徒学年・人数</label>
                  </td>
                  <td class="non-edit-cell">
                    {{ data?.desired_people_number }}
                  </td>
                </tr>
                <tr>
                  <td class="legend-cell bold">
                    <label for="school" class="school-label bold">実施地域(市区町村)</label>
                  </td>
                  <td class="non-edit-cell">
                    {{ data?.implementation_city }}
                  </td>
                </tr>
                <tr>
                  <td class="legend-cell bold">
                    <label for="school" class="school-label bold">実施場所</label>
                  </td>
                  <td class="non-edit-cell">
                    {{ data?.implementation_location }}
                  </td>
                </tr>
                <tr>
                  <td class="legend-cell bold">
                    <label for="school" class="school-label bold">実施日時</label>
                  </td>
                  <td class="non-edit-cell">
                    {{ data?.implementation_datetime }}
                  </td>
                </tr>
              </ng-container>


              <tr>
                <td class="legend-cell bold">
                  <label for="school" class="school-label bold">感想</label>
                </td>
                <td class="non-edit-cell">
                  {{ data?.impression }}
                </td>
              </tr>

              <tr>
                <td class="legend-cell bold">
                  <label for="school" class="school-label bold">アンケートへの回答状況</label>
                </td>
                <td class="non-edit-cell">
                  {{ data?.survey_answer_flg }}
                </td>
              </tr>

              <tr>
                <td class="legend-cell bold">
                  <label for="school" class="school-label bold">事例紹介への掲載可否</label>
                </td>
                <td class="non-edit-cell">
                  {{ data?.publish_flg }}
                </td>
              </tr>

              <tr>
                <td class="legend-cell bold">
                  <label for="school" class="school-label bold">実施概要</label>
                </td>
                <td class="non-edit-cell">
                  {{ data?.overview }}
                </td>
              </tr>
              <tr>
                <td class="legend-cell bold">
                  <label for="school" class="school-label bold">工夫したこと</label>
                </td>
                <td class="non-edit-cell">
                  {{ data?.ingenuity }}
                </td>
              </tr>
              <tr>
                <td class="legend-cell bold">
                  <label for="school" class="school-label bold">得られた成果</label>
                </td>
                <td class="non-edit-cell">
                  {{ data?.results }}
                </td>
              </tr>
              <tr>
                <td class="legend-cell bold">
                  <label for="school" class="school-label bold">写真</label>
                </td>
                <td class="non-edit-cell">
                  <img *ngIf="data?.image" [src]="data.image" alt="写真" style="max-width: 200px; max-height: 200px;" />
                </td>
              </tr>

            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</p-dialog>